import { render, staticRenderFns } from "./SetMatching.vue?vue&type=template&id=2b0705fa&scoped=true"
import script from "./SetMatching.vue?vue&type=script&lang=js"
export * from "./SetMatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0705fa",
  null
  
)

export default component.exports